import { call, put, takeEvery } from "redux-saga/effects"

// Customer Redux States
import { UPLOAD_FILE, REMOVE_FILE, UPLOAD_FILE_REQUEST, UPLOAD_PROFILE_IMG ,
  DELETE_PROFILE_IMG, DELETE_PROFILE_IMG_SUCCESS, DELETE_PROFILE_IMG_FAIL

} from "./actionTypes"
import * as ACTIONS from "store/actions";

import { postFile, postRemoveFile,postUploadProfileImg, postDeleteProfileImg } from "helpers/backend_helper"
import {errorMsg, successMsg} from "helpers/toastr";

 /**
      * Used for calling regarding file api's
      */


function* onAddFile({ payload: { data, callback } }) {


  try {
    const response = yield call(postFile, data)

    if (response.status == "failure") {
      return yield put(ACTIONS.uploadFileFail(response.message))
    }
    yield put(ACTIONS.uploadFileSuccess(response))
    callback && callback(response)

  } catch (error) {
    yield put(ACTIONS.uploadFileFail(error))
  }
}

function* onRemoveFile({ payload }) {
  try {
    const response = yield call(postRemoveFile, payload)

    if (response.status == "failure") {
      return yield put(ACTIONS.uploadFileFail(response.message))
    }
  } catch (error) {
    yield put(ACTIONS.uploadFileFail(error))
  }
}

function* onUploadProfile({ payload: { data, callback } }) {

  try {
    const response = yield call(postUploadProfileImg, data)

    if (response.status == "failure") {
      return yield put(ACTIONS.uploadProfileImgFail(response.message))
    }
    yield put(ACTIONS.uploadProfileImgSuccess(response))
    callback && callback(response)

    let authInfo = JSON.parse(localStorage.getItem("authUser"))
    authInfo.data.profileImage = response?.data?.profileImage;
    localStorage.setItem("authUser", JSON.stringify(authInfo));
    yield put(ACTIONS.loginSuccess(authInfo));


  } catch (error) {
    yield put(ACTIONS.uploadProfileImgFail(error))
  }
}


function* onDeleteProfileImg({ payload: { data, callback } }) {

  try {
    const response = yield call(postDeleteProfileImg, data)
    callback && callback(response)

    if (response.status == "failure") {
      return yield put(ACTIONS.deleteProfileImgFail(response.message))
    }
    yield put(ACTIONS.deleteProfileImgSuccess(response))

    let authInfo = JSON.parse(localStorage.getItem("authUser"))
    authInfo.data.profileImage = null;
    localStorage.setItem("authUser", JSON.stringify(authInfo));
    yield put(ACTIONS.loginSuccess(authInfo));


  } catch (error) {
    yield put(ACTIONS.deleteProfileImgFail(error))
  }
}


function* fileSaga() {
  yield takeEvery(UPLOAD_FILE_REQUEST, onAddFile)
  yield takeEvery(REMOVE_FILE, onRemoveFile)
  yield takeEvery(UPLOAD_PROFILE_IMG, onUploadProfile)
  yield takeEvery(DELETE_PROFILE_IMG, onDeleteProfileImg)

}

export default fileSaga
